import React from 'react';
import cn from 'classnames';

import styles from './index.module.scss';

/**
 * @param {object} props
 * @param {import('utils/types').ContainerVariant} [props.variant='contain']
 * @param {string} [props.className='']
 * @param {React.ReactNode} [props.children=null]
 */
export default function Container({
  variant = 'contain',
  className = '',
  children = null
}) {
  return (
    <div className={cn(styles.container, styles[variant], className)}>
      {children}
    </div>
  );
}
